import { render, staticRenderFns } from "./InfoBranch.vue?vue&type=template&id=01df2e18&scoped=true&"
import script from "./InfoBranch.vue?vue&type=script&lang=js&"
export * from "./InfoBranch.vue?vue&type=script&lang=js&"
import style0 from "./InfoBranch.vue?vue&type=style&index=0&id=01df2e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01df2e18",
  null
  
)

export default component.exports